export class PermisosVigentesDgt {
    fechaFin: Date;
    fechaInicio: Date;
    tipoPermiso: string;
    icono: string;
  }
